
<section *ngIf="showMessage" class="index h-75 d-flex">
  <div class="container container-wrapper h-25 screen-saver-container">
    <div class="row h-100 justify-content-center align-items-center text-center">
      <div class="col-12 col-xl-11">
        <div class="message-outer">
          <div class="message-middle">
            <div class="message-inner">
              <h2>{{ message | translate }}</h2>
              <!-- <div class="message-text" [innerHTML]="message | translate"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div (click)="click()" class="overlay"></div>
